import AdminTestBlock from "../../components/personal/AdminSettingsPage/AdminTests/AdminTestBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AdminTests = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Тесты"}>
            <AdminTestBlock/>
        </TypicalPageStructure>
        </>
    )
}
export default AdminTests;